export default __webpack_public_path__ + "static/lozenge-dropdown-dont-2-dark-2e098ed5aa6abf743ee09206d7f6cd2126672dcc033e3abf835e93a4ca0f8df2.png";